module.exports = __webpack_public_path__ + "files/cd8836448e12bac244b45a1c9069be03.png";